export default __webpack_public_path__ + "static/bg-wave-576c617b4eeb352daccc2d80f00cbc03.png";